import { type MessagesType } from './types';

/**
 * Ressources de traduction par défaut (français).
 * Utilisé lorsque la langue du navigateur est le français.
 */
const Messages: MessagesType = {
  // Langue / dropdown
  'language.label': 'Langue',
  'language.fr': 'Français',
  'language.en': 'English',

  // AppBar Console
  'console.title': 'Console',
  'console.auth.openLocked': 'Ouvrir la connexion Entra (non connecté)',
  'console.auth.openUnlocked': 'Ouvrir la connexion Entra (connecté)',
  'console.auth.modalTitle': 'Connexion Entra',
  'console.auth.modalSubtitle':
    'Même flux que Swagger : jeton d’accès Microsoft (client credentials).',
  'console.auth.modalBody':
    'Le jeton est stocké dans la session du navigateur et envoyé en Authorization: Bearer sur les appels API. Le webapp Nest ne transmet ce header que si BFF_FORWARD_CLIENT_AUTHORIZATION=true côté serveur (voir `apps/webapp/.env`).',
  'console.auth.swaggerInfo':
    'L’API doit tourner en tier local (`DEPLOYMENT_ENV=local`, ou équivalent) pour exposer la route (développement).',
  'console.auth.tokenActive': 'Jeton actif',
  'console.auth.expires': 'expire vers {date}',
  'console.auth.clientId': 'client_id (ID d’application Entra)',
  'console.auth.clientSecret': 'client_secret',
  'console.auth.showSecret': 'Afficher le secret',
  'console.auth.hideSecret': 'Masquer le secret',
  'console.auth.obtainToken': 'Obtenir un jeton',
  'console.auth.forgetToken': 'Oublier le jeton',
  'console.auth.errorMissing': 'Renseignez client_id et client_secret.',
  'console.auth.errorGeneric':
    'Erreur lors de l’obtention du jeton (vérifiez `DEPLOYMENT_ENV=local` sur l’API et les identifiants).',
  'console.auth.close': 'Fermer',
  'appBar.menuUser': 'Menu utilisateur',

  // Sidebar
  'sidebar.folder': 'Dossier',
  'sidebar.users': 'Utilisateurs',
  'sidebar.settings': 'Paramètres',

  // Page portefeuille
  'page.portfolioTitle': 'Portefeuille clients',
  'tabs.collect': 'Collecte',
  'tabs.equipment': 'Equipement',
  'search.placeholder': 'Rechercher',
  'search.ariaLabel': 'Rechercher',
  'filter.ariaLabel': 'Filtrer',

  // En-têtes tableau
  'table.entreprise': 'ENTREPRISE',
  'table.contact': 'CONTACT',
  'table.receptionFlux': 'RÉCEPTION FLUX',
  'table.fluxAchat': 'FLUX ACHAT',
  'table.fluxVente': 'FLUX VENTE',
  'table.fluxBanque': 'FLUX BANQUE',
  'table.paie': 'PAIE',
  'table.emailCollecte': 'EMAIL DE COLLECTE',
  'table.cabinet': 'CABINET',

  // Pagination
  'pagination.rowsPerPage': 'Lignes par page',
  'pagination.range': '1-10 sur 4549',
  'pagination.prev': 'Page précédente',
  'pagination.next': 'Page suivante',

  // Popover réception flux
  'popover.activated': 'Activé',
  'popover.errorLoadServices':
    "Impossible de charger la liste des services d'intégration.",
  'popover.integrationServiceLabel': "Service d'intégration",
  'popover.resendEmail': "Renvoyer l'email d'activation",
  'popover.connectService': 'Connecter un service',
  'popover.termsPrefix': 'Je reconnais avoir pris connaissance des',
  'popover.termsLink': "conditions d'utilisation",
  'popover.privacyLink': 'politique de confidentialité',
  'popover.termsSuffix': 'pour accéder à {serviceName}.',

  // Descriptions services (noms de services gardés tels quels)
  'serviceDescription.ouifacture':
    "OuiFacture est une solution de gestion et de production comptable pour les PME. Conçue pour centraliser la comptabilité, la paie et la gestion, elle s'intègre à l'écosystème Cegid afin d'alimenter les outils de production avec des données fiables, structurées et exploitables.",
  'serviceDescription.shinePlus':
    "Shine est un outil de facturation, de paiements, de pré-comptabilité et compte pro dédiée aux TPE. Conçue pour simplifier la collecte des données et sécuriser les flux financiers, elle s'intègre à l'écosystème Cegid afin d'alimenter les outils de production comptable avec des données fiables, structurées et exploitables.",

  // Dialog lien d'invitation
  'dialog.invitationTitle': "Lien d'invitation généré",
  'dialog.invitationDescription':
    "Partagez ce lien avec le client pour qu'il puisse générer ses clés API et finaliser la connexion du service.",
  'dialog.copy': 'Copier',

  // Console démo (dev) — aligné sur POST /internal/integrations/invite
  'consoleDemo.selectPartnerProduct':
    'Produit partenaire (partnerApplicationId)',
  'consoleDemo.inviteApiHint':
    'Démo : la liste provient de GET /internal/integration-partners ; chaque id est un partner_applications.id. L’origine de l’invitation est le client_id Entra du jeton (authentification Console).',
  'consoleDemo.debugOriginEntra': 'Outil requesteur Entra (label + client_id)',
  'consoleDemo.debugProductFromList': 'Produit (libellé liste)',
  'consoleDemo.debugPostBodyPrefix': 'POST body (JSON)',

  // Erreurs
  'error.linkGeneration': 'Erreur lors de la génération du lien.',

  // Page OuiFacture (dev)
  'ouiFacture.title': 'OuiFacture',
  'ouiFacture.settingsAriaLabel': 'Ouvrir les paramètres API',
  'ouiFacture.uploadCardTitle': 'Import facture de vente',
  'ouiFacture.uploadCardDescription':
    'Chargez une facture de vente (BMP, JPG, JPEG, PNG ou PDF) puis envoyez-la vers le service de votre expert-comptable.',
  'ouiFacture.apiKeyWarning':
    "Veuillez renseigner votre API key (client ID et client secret) via la roue crantée du menu pour activer l'import.",
  'ouiFacture.selectFileLabel': 'Fichier facture',
  'ouiFacture.filenameLabel': 'Nom du fichier',
  'ouiFacture.userEmailLabel': 'Email utilisateur',
  'ouiFacture.documentIdLabel': 'Document ID',
  'ouiFacture.sendButton': 'Envoyer',
  'ouiFacture.previewTitle': 'Aperçu du document',
  'ouiFacture.previewFrameTitle': 'Aperçu de la facture',
  'ouiFacture.previewEmptyState': 'Aucun document chargé pour le moment.',
  'ouiFacture.settingsDialogTitle': 'Configuration API OuiFacture',
  'ouiFacture.settingsDialogDescription':
    'Renseignez votre client ID et votre client secret pour activer le lien avec votre expert-comptable.',
  'ouiFacture.clientIdLabel': 'Client ID',
  'ouiFacture.clientSecretLabel': 'Client secret',
  'ouiFacture.settingsCancel': 'Annuler',
  'ouiFacture.settingsSave': 'Enregistrer',
  'ouiFacture.revokeButton': 'Révoquer la clé',
  'ouiFacture.revokeSuccess': 'Clé API révoquée avec succès.',
  'ouiFacture.revokeError':
    'Erreur lors de la révocation (clé introuvable ou déjà révoquée).',
  'ouiFacture.success': 'Import de facture de vente envoyé avec succès.',
  'ouiFacture.errorMissingFile':
    'Veuillez sélectionner un fichier avant envoi.',
  'ouiFacture.errorInvalidFileType':
    'Le fichier doit être au format BMP, JPG, JPEG, PNG ou PDF.',
  'ouiFacture.errorImportSalesInvoice':
    "Erreur lors de l'import de la facture de vente.",

  // Page invitation (génération ID clé d'API + Secret d'API)
  'invitation.pageTitle': 'Connexion à votre cabinet',
  'invitation.pageIntro':
    "Cette page permet de générer une clé API pour connecter votre logiciel (facturation, gestion…) à votre cabinet d'expertise comptable. Utilisez le lien d'invitation envoyé par votre expert pour accéder à cette fonctionnalité.",
  'invitation.errorNoTokenTitle': 'Lien invalide',
  'invitation.errorNoTokenBody':
    "Aucun lien d'invitation n'a été fourni. Utilisez le lien envoyé par votre expert comptable.",
  'invitation.errorInvalidLinkTitle': 'Lien invalide',
  'invitation.errorInvalidLinkBody':
    "Ce lien d'invitation est invalide. Demandez un nouveau lien à votre expert comptable.",
  'invitation.errorExpiredTitle': 'Lien expiré',
  'invitation.errorExpiredContactCpa':
    'Ce lien a expiré. Demandez un nouveau lien à votre expert comptable.',
  'invitation.errorExpiredIntegrationOwner':
    'Ce lien a expiré. Une intégration existe déjà pour {firstName} {lastName} ({email}).',
  'invitation.errorRevokedTitle': 'Lien révoqué',
  'invitation.errorRevokedBody':
    "Ce lien n'est plus valide. Demandez un nouveau lien à votre expert comptable.",
  'invitation.errorRevokedKeyAlreadyActiveTitle': "Clé d'API déjà créée",
  'invitation.errorRevokedKeyAlreadyActiveWithCreator':
    "Ce lien n'est plus valide : une clé d'API a déjà été générée pour ce logiciel par {firstName} {lastName} ({email}). L'invitation a été désactivée après cette création.",
  'invitation.errorRevokedKeyAlreadyActiveNoCreator':
    "Ce lien n'est plus valide : une clé d'API existe déjà pour ce logiciel. L'invitation a été désactivée. Contactez votre expert-comptable si vous avez besoin d'aide.",
  'invitation.revokedIntegrationsTitle': 'Identifiants d’intégration',
  'invitation.revokedIntegrationIdColumn': 'Identifiant',
  'invitation.revokedIntegrationStatusColumn': 'Statut',
  'invitation.revokedIntegrationStatusActive': 'Actif',
  'invitation.revokedIntegrationStatusRevoked': 'Révoqué',
  'invitation.revokedCopyId': "Copier l'identifiant",
  'invitation.revokedRenewSecret': 'Régénérer la clé secrète',
  'invitation.revokedRenewInProgress': 'Régénération…',
  'invitation.revokedRevokeKey': "Révoquer la clé d'API",
  'invitation.revokedActionsNeedEntra':
    'Une authentification Entra (outil conseiller) est requise pour ces actions.',
  'invitation.revokedRegenerateNeedSelection':
    'Sélectionnez exactement une intégration (active ou révoquée). Une nouvelle clé secrète est émise ; une ligne révoquée redevient active.',
  'invitation.revokedRevokeNeedSelection':
    'Sélectionnez au moins une intégration active à révoquer.',
  'invitation.revokedSelectAllActive': 'Tout sélectionner (actifs)',
  'invitation.revokedSelectRow': "Sélectionner l'intégration {id}",
  'invitation.revokedBulkRevokeSuccess':
    'Révocation : {revoked} révoquée(s), {already} déjà révoquée(s).',
  'invitation.revokedRegenerateSuccess':
    'Nouvelle clé secrète générée. Conservez-la en lieu sûr.',
  'invitation.revokedRevokeSuccess': "La clé d'API a été révoquée.",
  'invitation.revokedActionError': "L'action a échoué. Vérifiez votre session.",
  'invitation.revokedNewSecretTitle': 'Nouvelle clé secrète',
  'invitation.revokedDialogClose': 'Fermer',
  'invitation.retryButton': 'Réessayer',
  'invitation.errorConnectionTitle': 'Erreur de connexion',
  'invitation.verifyingLink': 'Vérification du lien en cours…',
  'invitation.sectionTitle': 'Enregistrement de votre clé API',
  'invitation.secureChip': 'Sécurisé',
  'invitation.cardSubtitle':
    "Votre comptable demande l'accès aux données de facturation de votre compte {integrationServiceLabel}.",
  // Récap + catalogue partenaire (même bloc, après validation du code) — placeholders {businessOwner}, {collaborator}, {inviterCompanyName}.
  'invitation.contextValidatedSummary':
    "Bonjour, {businessOwner}, cette demande d'accès aux données de facturation a été initiée par {collaborator} pour le cabinet de l'expert-comptable {inviterCompanyName}.",
  'invitation.codeExplanation':
    "Pour générer une clé API, saisissez d'abord le code à 6 chiffres envoyé par e-mail à {maskedEmail}.",
  'invitation.codeEmailFallback': 'votre adresse e-mail',
  'invitation.validateCodeButton': 'Valider',
  'invitation.validatingCode': 'Vérification…',
  'invitation.codeError': 'Code incorrect. Vérifiez le code reçu par e-mail.',
  'invitation.codeErrorExpired':
    'Le code a expiré. Utilisez le lien ci-dessus pour recevoir un nouveau code par e-mail.',
  'invitation.codeErrorMaxAttempts':
    'Trop de tentatives. Utilisez le lien ci-dessus pour recevoir un nouveau code par e-mail.',
  'invitation.codeDigitAria': 'Chiffre {index} du code',
  'invitation.resendCodeLink': 'Renvoyer le code par e-mail',
  'invitation.resendCodeWithCooldown':
    'Renvoyer le code par e-mail ({seconds} s)',
  'invitation.sendingCode': 'Envoi du code…',
  'invitation.codeResentSnackbar': "Le code vient d'être renvoyé par e-mail.",
  'invitation.infoInvoicingTitle': 'Données de facturation',
  'invitation.infoInvoicingText':
    'Connectez votre compte {integrationServiceLabel} pour partager vos données de facturation.',
  'invitation.infoSecureTitle': 'Privé et sécurisé',
  'invitation.infoSecureText':
    "Votre mot de passe n'est jamais demandé ni transmis lors de la connexion via API.",
  'invitation.infoControlTitle': 'Vous avez le contrôle',
  'invitation.infoControlText':
    'Retirez les autorisations accordées à tout moment.',
  'invitation.generateButton': 'Générer une clé API',
  'invitation.generating': 'Génération…',
  'invitation.publicApiIntegrationIdLabel':
    "Identifiant d'intégration API publique",
  'invitation.apiIntegrationSecretLabel': 'Secret de la clé',
  'invitation.copyPublicApiIntegrationId': "Copier l'identifiant d'intégration",
  'invitation.copyApiIntegrationSecret': 'Copier le secret',
  'invitation.showValue': 'Afficher',
  'invitation.hideValue': 'Masquer',
  'invitation.copiedIdSnackbar':
    "Identifiant d'intégration copié dans le presse-papier",
  'invitation.copiedSecretSnackbar': 'Secret copié dans le presse-papier',
  'invitation.explanatoryText':
    "Utilisez l'ID Clé d'API et le Secret d'API dans {integrationServiceLabel}, dans la section dédiée aux connexions ou aux paramètres d'API. Ne partagez jamais le Secret d'API avec des tiers et ne le communiquez pas par e-mail.",
  'invitation.generateErrorInvalidLink':
    "Ce lien n'est plus valide. Impossible de générer une clé.",
  'invitation.generateErrorSessionExpired':
    'La session a expiré. Veuillez recharger la page.',
};

export default Messages;
